import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const TalkingHead = () => {
    const { secretKey } = useParams();
    useEffect(() => {
        if (secretKey) {
            const script = document.createElement('script');
            script.src = import.meta.env.VITE_TH_WEB_CHAT_PATH as string;
            script.dataset.clientSecret = secretKey;
            document.body.append(script);
            script.setAttribute('name', 'web-chat');
            return () => {
                script.remove();
            };
        }
    }, [secretKey]);
    return false;
};

export default TalkingHead;
